import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import React from 'react';

export const NotShowable = <T extends { url?: string | null }>({
  data,
}: {
  data: T;
}) => {
  return (
    <div className="flex justify-center items-center grow bg-semantic-surface-faint flex-col gap-2 h-full">
      <div className="text-sm text-semantic-content-subtle text-center px-1">
        {data.url
          ? 'Seda graafikut ei saa praegu kuvada, kuid statistika on saadaval ametlikus andmeallikas.'
          : 'Seda graafikut ei saa praegu kuvada.'}
      </div>
      {data.url && (
        <Button
          onClick={(e) => {
            e.stopPropagation();
          }}
          compact
          variant="secondary"
          href={data.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Vaata lähemalt
        </Button>
      )}
    </div>
  );
};
